import { Component } from 'san';
import * as _ from 'lodash';
import { Select } from 'santd';


import { IProjectAttribute } from 'src/models';
import LeanInputCell from '../LeanInputCell/LeanInputCell';
import leanService from 'src/services/lean.service';


export default class LeanProjectSelect extends Component {
    static components = {
        'ui-lean-input-cell': LeanInputCell,
        's-select': Select,
        's-select-option': Select.Option,
    };

    static computed = {
        codes() {
            const value = this.data.get('value');
            return value ? [value.code] : [];
        },
        optionDeleted() {
            const options = this.data.get('options');
            const value = this.data.get('value');
            if (!value) {
                return;
            }
            if (-1 === _.findIndex(options, { code: value.code })) {
                return value;
            }
        }
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        focusId: string;    // {{}} 当前focus的组件的id，用来高亮组件
        id: string; // {{}}
        title: string;  // {{}}
        value: IProjectAttribute;   // {==}
        options: IProjectAttribute[];   // 列表项
        isRequired: boolean;    // {{}}
        disabled: boolean;  // {{}}
    } {
        return {
            focusId: null,
            id: null,
            title: '',
            value: null,
            options: [],
            isRequired: false,
            disabled: false,
        };
    }

    inited(): void {
    }

    handleChange(codes: string[]) {
        if (!codes) {
            return;
        }

        const dataKey = 'options';
        const options = this.data.get(dataKey);

        // 更新value
        const value = _.find(options, (item) => {
            return _.includes(codes, item.code);
        });
        this.data.set('value', value);
        this.fireValueChange(value);
    }

    onFocus() {
        (this.ref('select') as any).setOpenState(true); // santd Select 获取焦点并打开下拉框
        this.fire('focus', this.data.get('id'));
    }

    onBlur() {
        (this.ref('select') as any).setOpenState(false); // santd Select 移除焦点并关闭下拉框
        this.fire('blur', this.data.get('id'));
    }

    onClick() {
        // 由于 Select的 bug（单选 且 showSearch=true 时，on-focus事件捕获不到），在此手动触发on-focus
        this.onFocus();
    }

    onIconClick() {
        this.onClick();
    }

    fireValueChange(value: IProjectAttribute) {
        this.fire('value-change', value);
    }

    getPopupContainer() {
        return () => this.el;
    }

    onDropdownVisibleChange(open: boolean) {
        leanService.patchOnDropdownVisibleChange(open, this.el, this.data.get('value'), this.data.get('options'));
    }
}
